import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./maybe-dismissable.css.ts.vanilla.css-mistica.js";
var f = "cim30m2 _1y2v1nf7m _1y2v1nf8v _1y2v1nfa4 _1y2v1nfbd _1y2v1nfhf _1y2v1nfkr _1y2v1nfll", y = "_1y2v1nfhe _1y2v1nfhk _1y2v1nfi2";
export { f as dismissableButton, y as dismissableContainer };
